import { render, staticRenderFns } from "./video.vue?vue&type=template&id=7c7e4f2c&scoped=true&"
import script from "./video.vue?vue&type=script&lang=ts&"
export * from "./video.vue?vue&type=script&lang=ts&"
import style0 from "./video.vue?vue&type=style&index=0&id=7c7e4f2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7e4f2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/aef.slmndr.be/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7e4f2c')) {
      api.createRecord('7c7e4f2c', component.options)
    } else {
      api.reload('7c7e4f2c', component.options)
    }
    module.hot.accept("./video.vue?vue&type=template&id=7c7e4f2c&scoped=true&", function () {
      api.rerender('7c7e4f2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/wordpress/video.vue"
export default component.exports